var $5012d21d933388c1$exports = {};
$5012d21d933388c1$exports = {
  "Clear search": "Clear search"
};
export { $5012d21d933388c1$exports as default };